module.exports = __webpack_public_path__ + "img/avatar_sm.0f19e179.png";